import React, { ReactElement, useEffect } from 'react';
import MeetingsRouter from '../../../../router/meetingsrouter';
import { dataContext } from '../../../../hooks/datatabs';

function DdMeetings(): ReactElement {
  const dd = dataContext();
  const [readonly, setReadonly] = React.useState(false);

  useEffect(() => {
    if (dd && dd.dueDiligence) {

      dd.dueDiligence.lifecycle?.activities.forEach((activity) => {
        if (activity.id === 'meeting') {
          if (activity.status === 'started' || activity.status === 'reopened') {
            setReadonly(false);
          } else {
            setReadonly(true);
          }
        }
      });
    }
  }, [dd]);

  return (
    <MeetingsRouter readonly={readonly} />
  );
}

export default DdMeetings;
